import { useI18n } from '@muse/i18n'
import { useEffect } from 'react'
import { sendEvent } from '@core/analytics'

import { MusehubBanner, type TMusehubBannerSize } from '../components/musehub-banner'
import { MUSEHUB_BANNERS, type TMusehubBannerId } from '../constants/musehubBanners'

export type TMusehubBannerContainerProps = {
    banner: TMusehubBannerId
    size?: TMusehubBannerSize
    trackView?: boolean
}

export const MusehubBannerContainer = ({
    banner,
    size = 'large',
    trackView = true,
}: TMusehubBannerContainerProps) => {
    const { t } = useI18n()
    const content = MUSEHUB_BANNERS[banner]

    useEffect(() => {
        if (trackView) {
            sendEvent({ name: 'mbanner_show', payload: {} })
        }
    }, [trackView])

    const handleClick = () => {
        sendEvent({ name: 'mbanner_click', payload: {} })
    }

    return (
        <MusehubBanner
            cover={content.cover}
            label={content.label}
            title={content.title}
            description={content.description}
            offer={content.offer}
            href={content.link}
            cta={t('i18n.commonTryNow')}
            size={size}
            onClick={handleClick}
        />
    )
}
